//
//
//
//
//
//
//
//
//

export default {
name: "SearchIcon",
}
